import type { RootState } from '..';
import type { IAgentPositionState } from '../types';

export const selectAgentPositions = (state: RootState): IAgentPositionState['agentPositions'] =>
  state.agentPosition.agentPositions;

export const selectAgentPositionPending = (state: RootState): string[] => state.agentPosition.meta.pending;

export const selectAgentPositionPendingAction =
  (actionType: string) =>
  (state: RootState): boolean =>
    state.agentPosition.meta.pending.some(action => action === actionType);
